import { OnInit, Component, ViewChild } from '@angular/core';
import { SearchFilter, IFilterResponse } from '../../../../infrastructure/iFilter-component';
import { MatTableDataSource, MatSort } from '@angular/material';
import { SearchCompleteFilterComponent } from '../../../controls/search-complete-filter/search-complete-filter.component';
import { Router } from '@angular/router';
import { MenuService } from '../../../../services/menu.service';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { PagerControlComponent } from '../../../controls/pager/pager-control.component';
import { LogisticsService } from '../../../../services/logistics.service';
import { ConfirmDialogService } from '../../../../services/confirm-dialog.service';
import { StudyReportBatch } from '../../../../model/logistics/study-report';
import { AuthService } from '../../../../services/auth.service';
 
@Component({
  selector: 'app-receive-study-report-logistics-search',
  templateUrl: './receive-study-report-logistics-search.component.html'
})
export class ReceiveStudyReportLogisticsSearchComponent implements OnInit {

  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  displayedColumns: string[] = ['name', 'star'];
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchCompleteFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor(
    private router: Router
    , private menuService: MenuService
    , private logisticsService: LogisticsService
    , private authService: AuthService
    , private confirmDialogService: ConfirmDialogService
    , private notificationToastService: NotificationToastService) {
    this.menuService.setMenuTitle('Logística', 'recepción de informes');
  }

  ngOnInit(): void {

  }

  rollBackStudyReportBach(studyReportBatch: StudyReportBatch): void {
    if (!studyReportBatch.CanEdit) {
      this.confirmDialogService.confirm('Revertir lote'
      , 'Está seguro que desea revertir el lote?', 'Sí', 'No').subscribe(async (value) => {
        if (value) {
          try {
            this.loading = true;
            await this.logisticsService.studyReportBatchRollBack(studyReportBatch, this.authService.getSectorId());
            await this.searchFilter.search();
          } catch (err) {
            this.notificationToastService.error(JSON.stringify(err), 'Recepción de informes');
          } finally {
            this.loading = false;
          }
        }
      });
    }
  }

  receiveStudyReportBach(studyReportBatch: StudyReportBatch): void {
    if (studyReportBatch.CanEdit) {
      this.router.navigate(['receive-study-report-logistics-wizard', studyReportBatch.Id]);
    }
  }

  onStartSearch(): void {
    this.loading = true;
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<StudyReportBatch>): void {
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
  }
}
